import { StateCreator } from 'zustand';

import { Store } from '@/store';

export interface PageCacheState {
  cacheData: Record<string, any>; // 存储各个页面的缓存数据
}

export interface PageCacheActions {
  getPageCache: (pageKey: string) => any;
  setPageCache: (pageKey: string, data: any) => void;
  updatePageCache: (pageKey: string, partialData: any) => void;
  clearPageCache: (pageKey: string) => void;
  clearPageCacheByPrefix: (prefix: string) => void;
  clearAllPageCache: () => void;
}

export type PageCacheSlice = PageCacheState & PageCacheActions;

export const initialPageCacheState: PageCacheState = {
  cacheData: {},
};

export const createPageCacheSlice: StateCreator<Store, [], [], PageCacheSlice> = (set, get) => {
  return {
    ...initialPageCacheState,

    // 获取页面缓存
    getPageCache: (pageKey: string) => {
      return get().cacheData[pageKey] || null;
    },

    // 设置页面缓存
    setPageCache: (pageKey: string, data: any) => {
      set((state) => ({
        cacheData: {
          ...state.cacheData,
          [pageKey]: data,
        },
      }));
    },

    // 更新页面缓存（部分更新）
    updatePageCache: (pageKey: string, partialData: any) => {
      const currentData = get().cacheData[pageKey] || {};
      const newData = { ...currentData, ...partialData };

      set((state) => ({
        cacheData: {
          ...state.cacheData,
          [pageKey]: newData,
        },
      }));
    },

    // 清除特定页面缓存
    clearPageCache: (pageKey: string) => {
      set((state) => {
        const newCacheData = { ...state.cacheData };
        delete newCacheData[pageKey];
        return { cacheData: newCacheData };
      });
    },

    // 按前缀清除页面缓存
    clearPageCacheByPrefix: (prefix: string) => {
      set((state) => {
        const newCacheData = { ...state.cacheData };

        // 找到所有匹配前缀的 key 并删除
        Object.keys(newCacheData).forEach((key) => {
          if (key.startsWith(prefix)) {
            delete newCacheData[key];
          }
        });

        return { cacheData: newCacheData };
      });
    },

    // 清除所有页面缓存
    clearAllPageCache: () => {
      set({ cacheData: {} });
    },
  };
};
